jQuery(function ($) {
    var windowWidth = window.innerWidth;
    var body = 'body';
    var $window = $(window);

    /*--------------------------------------------------------------
    # Hamburger Menu
    --------------------------------------------------------------*/
    var menuBtn = '[data-menu-btn]';
    var mainNav = '[data-main-nav]';

    $(menuBtn).on('click', function () {
        $(this).toggleClass('open');
        $('.header-wrapper').toggleClass('nav-open');
        $(body).toggleClass('overlay');
    });

    var parentLink = $(mainNav).find('.menu-item-has-children');
    parentLink.on('click', function () {
        $(this).find('.sub-menu').slideToggle();
    });

    /*--------------------------------------------------------------
    # Slick Slider
    --------------------------------------------------------------*/
    var slider = '[data-slider]';
    $(slider).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        arrows: true,
        nextArrow: $('.home-right'),
        prevArrow: $('.home-left'),
    });

    /*--------------------------------------------------------------
    # Hero Slider
    --------------------------------------------------------------*/
    function sliderInit() {
        $('.hero-slider-wrapper').slick({
            dots: false,
            slidesToShow: 1,
            pauseOnFocus: false,
            pauseOnHover: false,
            responsive: [
                {
                    breakpoint: 769,
                    settings: "unslick"
                }
            ]
        });

        // Erease text within slick slider buttons
        if ($('.hero-slider-wrapper .slick-next')) {
            // $('.hero-slider-wrapper .slick-next').text('').addClass('font-slider-arrow');
            // $('.hero-slider-wrapper .slick-prev').text('').addClass('font-slider-arrow');
        }
        $('.hero-slider-wrapper-arrow .home-left').append('<i class="material-icons white12">arrow_forward</i>');
        $('.hero-slider-wrapper-arrow .home-right').append('<i class="material-icons white23">arrow_back</i>');
    }

    // sliderInit();
    // $(window).on('resize', function() {
    //     if ($(window).width() > 768) {
    //         sliderInit();
    //     }
    // })


    /*--------------------------------------------------------------
    # Beardsmen Slider
    --------------------------------------------------------------*/
    $('.beardsmen-slider-wrapper').slick({
        slidesToShow: 4,
        dots: false,
        arrows: false,
        responsive: [{
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    })

    $('.beardsmen-slider-wrapper').slickLightbox({
        itemSelector: 'a',
        navigateByKeyboard: true,
        nextArrow: $('.beardsmen-next'),
        prevArrow: $('.beardsmen-prev')
    }).on({
        'show.slickLightbox': function () {
            $('.slick-next').text('').addClass('font-slider-arrow');
            $('.slick-prev').text('').addClass('font-slider-arrow');
        },
        'hide.slickLightbox': function () {
            $('body').removeClass('prevent-desktop-scrolling');
        }
    });

    $('.beardsmen-prev').click(function () {
        $('.beardsmen-slider-wrapper').slick('slickPrev');
    });
    $('.beardsmen-next').click(function () {
        $('.beardsmen-slider-wrapper').slick('slickNext');
    });

    /*--------------------------------------------------------------
    # Testimonial Slider
    --------------------------------------------------------------*/
    $('.testimonials-wrapper').slick({
        arrows: false,
        dots: true,
        autoplay: true
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.slick-dots li button').empty();
    });


    /*--------------------------------------------------------------
    # Featured Products Slider
    --------------------------------------------------------------*/
    function changeHomeShopArrows() {
        $('.featured-products-list .slick-next').append('<i class="material-icons">arrow_forward</i>');
        $('.featured-products-list .slick-prev').append('<i class="material-icons">arrow_back</i>');
    }

    $('.featured-products-list').on('init', changeHomeShopArrows);
    $('.featured-products-list').slick({
            autoplay: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            responsive: [{
                    breakpoint: 1441,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 481,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        })
        .on('breakpoint', changeHomeShopArrows);

    /*--------------------------------------------------------------
    # Header Config
    --------------------------------------------------------------*/


    /*--------------------------------------------------------------
    # Parallax
    --------------------------------------------------------------*/

    // function parallax(selector, speed) {
    //     if (selector.length !== 0 && $(window).width() > 992) {
    //         var sectionOffset = selector.offset().top;
    //         var scrolled = $(window).scrollTop() - sectionOffset;
    //         if ($(selector).hasClass('background')) {
    //             var sectionPosition = "0 calc(50% + " + ((scrolled * speed)) + 'px)';
    //         } else {
    //             var sectionPosition = "50% calc(100% + " + ((scrolled * speed)) + 'px)';
    //         }
    //         selector.css('background-position', sectionPosition);
    //     }
    // }

    // $(window).on('scroll', function () {
    //     parallax($('.parallax'), 0.4);
    // });

    // ------------------------------------------------

    if (windowWidth > 992) {
        function parallax(selector, speed) {
          if (selector.length !== 0 ) {
            var sectionOffset = selector.offset().top;
            var scrolled = $(window).scrollTop() - sectionOffset;
            var sectionPosition = "center " + ((scrolled * speed))  + 'px';
            selector.css('background-position', sectionPosition);
        }
    }

    parallax($('.parallax'), 0.4);
        $(window).on('scroll', function(){
            parallax($('.parallax'), 0.4);
        });
    }

    /*--------------------------------------------------------------
    # Shop page - left nav get position fixed on scroll
    --------------------------------------------------------------*/

    // Fix woo-sidebar on desktop devices
    function fixSidebar() {

        if ($('.woo-sidebar').length > 0) {
            var stickyTop = $('.shop-section').offset().top;
            var stickyBottom = stickyTop + $('.woo-sidebar').outerHeight();
            var footerTop = $('.site-footer').offset().top;
            var sidebarOffsetTop = -($('.woo-sidebar').offset().top + $(window).outerHeight() - footerTop + 100);

            if ($(window).width() > 991) {
                if ($(window).scrollTop() >= stickyTop && $('.shop-section').height() > $(window).height()) {
                    $('.shop-section').addClass('shop-fixed');
                    if (($('.woo-sidebar').offset().top + $(window).outerHeight()) >= footerTop) {
                        $('.woo-sidebar .custom-woo-widget').css('top', sidebarOffsetTop + 'px');
                    } else {
                        $('.woo-sidebar .custom-woo-widget').css('top', 0);
                    }
                } else {
                    $('.shop-section').removeClass('shop-fixed');
                }
            } else {
                if ($(window).scrollTop() >= stickyTop) {
                    $('.shop-section').addClass('shop-fixed-mobile');
                } else {
                    $('.shop-section').removeClass('shop-fixed-mobile');
                }
            }
        }
    }

    $(window).on('scroll', fixSidebar);

    /*--------------------------------------------------------------
    # Show left nav on shop page on small screen
    --------------------------------------------------------------*/

    $('.woo-btn').on('click', function (e) {
        e.stopPropagation();
        $('.woo-sidebar').toggleClass('woo-open');
    });
    $(window).on('click', function (e) {
        if (!$(e.target).hasClass('woo-open') && $('.woo-sidebar').hasClass('woo-open')) {
            $('.woo-sidebar').toggleClass('woo-open');
        }
    });
    $(window).on('keydown', function (e) {
        if ($('.woo-sidebar').hasClass('woo-open') && (e.keyCode === 27 || e.which === 27)) {
            $('.woo-sidebar').toggleClass('woo-open');
        }
    });


    /*--------------------------------------------------------------
    # Engraving field config
    --------------------------------------------------------------*/
    function getEngravingValue() {
        var engravingMatch = $(this).val().toLowerCase();

        if (engravingMatch === 'sa gravurom' || engravingMatch === 'with engraving') {
            if (localize_params.site_lang === 'sr') {
                $('.wccpf_label label').text('Personalizacija');
                $('.wccpf_value .wccpf-field ').attr('placeholder', 'Dodaj gravuru');
            }
            $('.wccpf_value .wccpf-field ').val('');
            $('.single_add_to_cart_button').prop('disabled', true).addClass('wc-variation-selection-needed').css({
                'background-color': '#d8be77',
                'color': '#000'
            });
            $('.wccpf-fields-group-container').css('display', 'block');
            return;
        } else {
            $('.wccpf-fields-group-container').css('display', 'none');
            $('.single_add_to_cart_button').prop('disabled', false).removeClass('wc-variation-selection-needed');
        }
    }


    function validateField(e) {
        var val = this.value;

        if (/\S/.test(val)) {
           // console.log('drugi karakteri')
            $('.single_add_to_cart_button').prop('disabled', false);
        } else{
           // console.log('samo space')
            $('.single_add_to_cart_button').prop('disabled', true);
        }



        //var str = trim(this.value);
        // if (this.value !== ' ' && this.value !== null) {
        // if(str != '' && str != null) {
        //     $('.single_add_to_cart_button').prop('disabled', false);
        // } else {
        //     $('.single_add_to_cart_button').prop('disabled', true);
        // }
    }

    $('.wccpf-fields-group-container').css('display', 'none');
    $('#personalization').on('change', getEngravingValue);
    $('.wccpf_value .wccpf-field ').on('input', validateField);

    /*--------------------------------------------------------------
    # Woo-btn toggle class
    --------------------------------------------------------------*/

    $('.woo-sidebar .material-icons').on('click', function () {
        $('.material-icons').toggleClass('material-icons-invert');
    });

    /*--------------------------------------------------------------
    # Woo-btn toggle end
    --------------------------------------------------------------*/


    /*--------------------------------------------------------------
    # Preloader config
    --------------------------------------------------------------*/

    if ($('body').hasClass('home')) {
        if ($('#preloader').length) {
            $('#preloader').addClass('preloader-load');
        }

        $(window).on('load', function () {
            setTimeout(function () {
                $('body').addClass('load');
                $('#preloader').removeClass('preloader-load');
                $('#preloader').addClass('preloader-stop');
            }, 1000);
        });
    }


    /*--------------------------------------------------------------
    # Show reviews first on single product page
    --------------------------------------------------------------*/
    $('.woocommerce-tabs li').removeClass('active');
    $('.woocommerce-Tabs-panel').hide();
    $('.reviews_tab').addClass('active');
    $('.woocommerce-Tabs-panel--reviews').show();


    /*--------------------------------------------------------------
    # Add notificatoin element after Cart Total
    --------------------------------------------------------------*/
    if (user_params.active) {
        $('.wc-proceed-to-checkout').before(user_params.discount_info);
    }


    /*--------------------------------------------------------------
    # Add space woocommerce price
    --------------------------------------------------------------*/

    $(".woocommerce-Price-currencySymbol").append("<span>&nbsp;</span>");

    /*--------------------------------------------------------------
    # End woocommerce price
    --------------------------------------------------------------*/


    /*--------------------------------------------------------------
    # The end
    --------------------------------------------------------------*/


    // get random number to check if script has run
    // console.log(Math.random() * 10);


    $('.gdpr-agreement').on('click', function(){
        $('.gdpr').addClass('gdpr-close-bar');
    });

    $('.gdpr-close').on('click', function(){
        $('.gdpr').addClass('gdpr-close-bar');
    });
});
